<script>
export default {
  functional: true,

  render(h, { data, slots, $style }) {
    return (
      <div {...data}>
        {slots().default &&
          slots().default.map(vnode => <div class={$style.item}>{vnode}</div>)}
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.item {
  & ~ & {
    margin-top: 0.5rem;
  }
}
</style>
